const aside_contact = document.querySelectorAll('[data-aside-contact]');

if (aside_contact) {
  aside_contact.forEach((ac) => {
    ac.addEventListener('click', () => {
      if (!ac.classList.contains('on')) {
        ac.classList.add('on');
        setTimeout(() => {
          ac.style.maxHeight = 'none';
        }, 400);
      }
    });
  });
}